module.exports = __webpack_public_path__ + "img/zhaoshang_peixun@2x.84c701fa.png";